const ZIndex = {
  /*
    LEVEL 0
    Turntable: Nothing, this is below the data table
  */
  level0: 0,
  /*
    LEVEL 100
    Spaces: ContentContainer (everything to the right of the sidebar), full screen page not found page, sidebar
  */
  level100: 100,
  /*
    LEVEL 200
    Turntable: Cells and cell outlines
    Spaces: Sidebar collapse/expand button
  */
  level200: 200,
  /*
    LEVEL 300
    Turntable: Cell tooltips
  */
  level300: 300,
  /*
    LEVEL 400
    Turntable: Cell inner
  */
  level400: 400,
  /*
    LEVEL 500
    Turntable: Cell editors
  */
  level500: 500,
  /*
    LEVEL 600
    Turntable: Pinned columns
  */
  level600: 600,
  /*
    LEVEL 700
    Turntable: Column Headers
  */
  level700: 700,
  /*
    LEVEL 750
    Turntable: Empty state. Above the table, below the toolbar.
  */
  level750: 750,
  /*
    LEVEL 800
    Turntable: Index corner cell
    Spaces: 'Add data' overlay for empty table
  */
  level800: 800,
  /*
    LEVEL 900
    Turntable: Toolbar
   */
  level900: 900,
  /*
    LEVEL 1000
    Turntable: nothing, this should be above the data table
    Spaces: Jobs panel, tooltips
    Design system: context menus, dropdowns, popovers,
   */
  level1000: 1e3,
  /*
    LEVEL 1100
    Turntable: nothing, this should be above the data table
    Spaces: File upload overlay
   */
  level1100: 1100,
  /*
    LEVEL 1200
    Turntable: nothing, this should be above the data table
    Spaces: File => workbook flow (workbook selection, mapping etc), modals
   */
  level1200: 1200
};
export {
  ZIndex
};
